import { connect } from "react-redux";
import ComparingBanner from "./ComparingBanner";
import { matchModeLabel } from "../../../../../TrendComparison/constants";
import { selectTrendTotals } from "../../../../../TrendComparison/utils/selectTrendTotals";

// The gap between the two rounds being compared, as the trend self-vs-others
// response reports it across everyone in the comparison: min/maxDifference, in
// months. Read from the same slice What moved most is drawn from, so the banner
// describes the intervals those sections are actually built on.
//
// Passed through as they come, undefined included — the banner leaves the
// sentence out rather than inventing a range, which is also what it does while
// the response is still on its way.
const mapStateToProps = (state) => {
    const api = state.BenchmarkFilteringReducer.fetchTrendSelfVsOthersApi;
    const { data } = api;
    // The same split the picker's own summary and footer quote, taken from the
    // load that built the lists rather than the latest response — so a search
    // over the tables up there can't rewrite a line about the charts down here.
    const { comparedCount, notComparedCount } = selectTrendTotals(state);
    return {
        comparedCount,
        notComparedCount,
        // The pairing the results were built from, not the one being edited in
        // the picker — same label the summary line up there carries, from the
        // same helper, so the two can't describe one comparison two ways.
        baselineLabel: matchModeLabel(state.BenchmarkFilteringReducer.trendPairing.applied.matchMode),
        // The slice itself as well as the range, since the banner waits on this
        // call through AsyncSection — see the note there.
        api,
        intervalFrom: data ? data.minDifference : undefined,
        intervalTo: data ? data.maxDifference : undefined,
    };
};

export default connect(mapStateToProps)(ComparingBanner);
